function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlayPause = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 74.53 39.84"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M19.94 0H71a3.57 3.57 0 0 1 3.57 3.57v32.71A3.56 3.56 0 0 1 71 39.84H20A19.93 19.93 0 0 1 19.65 0Z",
  style: {
    fill: "#fff",
    fillRule: "evenodd",
    opacity: 0.2,
    isolation: "isolate"
  }
}));
export { SvgPlayPause as ReactComponent };
export default __webpack_public_path__ + "static/media/play_pause.ed2639ed.svg";